import { render, staticRenderFns } from "./dropcart.vue?vue&type=template&id=27b3f3b6"
import script from "./dropcart.vue?vue&type=script&lang=ts"
export * from "./dropcart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports